import { categories } from "@/mocks/categories";
import CategoryCard from "@/components/base/CategoryCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategoryGate() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="四大栏目"
          title="想看哪一类，直接进哪一栏"
          desc="每一个热点都可以从不同维度被看见。选一个方向，开始高效浏览。"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => (
            <CategoryCard key={c.slug} cat={c} />
          ))}
        </div>
      </div>
    </section>
  );
}